import { css } from 'styled-components';

export const readOnly = css`
  background: none;
  color: black;
  border: none;
  padding-left: 0;
  cursor: auto;
`;
